export default __webpack_public_path__ + "static/media/brSideNavBg.d348a6b4.png";